import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// no lazy loading for auth pages to avoid flickering
const AuthLayout = React.lazy(() => import('@app/components/layouts/AuthLayout/AuthLayout'));
import LoginPage from '@app/pages/LoginPage';
import SignUpPage from '@app/pages/SignUpPage';
import ForgotPasswordPage from '@app/pages/ForgotPasswordPage';
import SecurityCodePage from '@app/pages/SecurityCodePage';
import NewPasswordPage from '@app/pages/NewPasswordPage';
import LockPage from '@app/pages/LockPage';

import MainLayout from '@app/components/layouts/main/MainLayout/MainLayout';
import RequireAuth from '@app/components/router/RequireAuth';
import { withLoading } from '@app/hocs/withLoading.hoc';
import NftDashboardPage from '@app/pages/DashboardPages/NftDashboardPage';
import MedicalDashboardPage from '@app/pages/DashboardPages/MedicalDashboardPage';

import CustomerLogin from '../auth/CustomerLogin/CustomerLogin';
import MyAccountsPage from '@app/pages/MyAccountPage/MyAccountPage';
import AllUserRoles from '@app/pages/UserRolespage/AllUserRoles';
import CreateUserRolePage from '@app/pages/UserRolespage/CreateUserRoles';
import ViewUserRolePage from '@app/pages/UserRolespage/ViewUserRole';
import EditUserRolePage from '@app/pages/UserRolespage/EditUserRole';
import AllUsers from '@app/pages/UsersPage/AllUsers';
import CreateUserPage from '@app/pages/UsersPage/CreateUser';
import EditUserPage from '@app/pages/UsersPage/EditUser';
import ViewUserPage from '@app/pages/UsersPage/ViewUser';
import CustomersPage from '@app/pages/CustomerPages/CustomersPage';
import EditCustomerPage from '@app/pages/CustomerPages/EditCustomerPage';
import ViewCustomerPage from '@app/pages/CustomerPages/ViewCustomerPage';

import AllProducts from '@app/pages/ProductsPage/AllProducts';
import CreateProductPage from '@app/pages/ProductsPage/CreateProduct';
import EditCategoryPage from '@app/pages/ProductCategoryPage/EditCategory';
import ViewCategoryPage from '@app/pages/ProductCategoryPage/ViewCategory';
import EditProductPage from '@app/pages/ProductsPage/EditProduct';
import ViewProductPage from '@app/pages/ProductsPage/ViewProduct';
import AllProductVarietiesPage from '@app/pages/ProductVarietyPages/AllProductVarietiesPage';
import CreateProductVarietiesPage from '@app/pages/ProductVarietyPages/CreateProductVarietiesPage';
import EditProductVarietiesPage from '@app/pages/ProductVarietyPages/EditProductVarietiesPage';
import ViewProductVarietiesPage from '@app/pages/ProductVarietyPages/ViewProductVarietiesPage';
import AllLocations from '@app/pages/LocationsPage/AllLocations';
import CreatelocationPage from '@app/pages/LocationsPage/CreateLocation';
import CreateProductPricingPage from '@app/pages/ProductPricingPages/CreateProductPricingPage';
import ViewProductPricingPage from '@app/pages/ProductPricingPages/ViewProductPricingPage';
import EditProductPricingPage from '@app/pages/ProductPricingPages/EditProductPricingPage';
import AllCategories from '@app/pages/ProductCategoryPage/AllCategories';
import CreateCategory from '@app/pages/ProductCategoryPage/CreateCategory';
import EditCategory from '@app/pages/ProductCategoryPage/EditCategory';
import ViewCategory from '@app/pages/ProductCategoryPage/ViewCategory';
import CreateLocationPage from '@app/pages/LocationsPage/CreateLocation';
import EditLocationPage from '@app/pages/LocationsPage/EditLocation';
import ViewLocationPage from '@app/pages/LocationsPage/ViewLocation';
import AllDepartments from '@app/pages/DepartmentPages/AllDepartments';
import CreateDepartmentPage from '@app/pages/DepartmentPages/CreateDepartment';
import EditDepartmentPage from '@app/pages/DepartmentPages/EditDepartment';
import ViewDepartmentPage from '@app/pages/DepartmentPages/ViewDepartment';
import AllPreClearance from '@app/pages/PreClearancePages/AllPreClearance';
import CreatePreClearancePage from '@app/pages/PreClearancePages/CreatePreClearance';
import EditPreClearancePage from '@app/pages/PreClearancePages/EditPreClearance';
import ViewPreClearancePage from '@app/pages/PreClearancePages/ViewPreClearance';
import AllRegistrations from '@app/pages/ProductRegistrationPages/AllRegistrations';
import RegisterProductPage from '@app/pages/ProductRegistrationPages/RegisterProduct';
import AllPRCategories from '@app/pages/PRCategoryPages/AllPRCategories';
import CreatePRCategoryPage from '@app/pages/PRCategoryPages/CreatePRCategory';
import EditPRCategoryPage from '@app/pages/PRCategoryPages/EditPRCategory';
import ViewPRCategoryPage from '@app/pages/PRCategoryPages/ViewPRCategory';
import AllPRProducts from '@app/pages/PRProductPages/AllPRProducts';
import CreatePRProductPage from '@app/pages/PRProductPages/CreatePRProduct';
import EditPRProductPage from '@app/pages/PRProductPages/EditPRProduct';
import ViewPRProductPage from '@app/pages/PRProductPages/ViewPRProducts';
import AllPRProcesses from '@app/pages/PRProcessPages/AllProcesses';
import CreatePRProcessPage from '@app/pages/PRProcessPages/CreatePRProcess';
import EditPRProcessPage from '@app/pages/PRProcessPages/EditPRPocess';
import ViewPRProcessPage from '@app/pages/PRProcessPages/ViewPRProcess';
import EditPRIFSPage from '@app/pages/ProductRegistrationPages/EditIFSRegistration';
import ViewPRIFSPage from '@app/pages/ProductRegistrationPages/ViewRegistration';
const HomePage = React.lazy(() => import('@app/pages/HomePage/HomePage'));
import AllPreClearanceCategories from '@app/pages/PreClearanceCategoryPage/AllPreClearanceCategories';
import CreatePreClearanceCategoryPage from '@app/pages/PreClearanceCategoryPage/CreatePreClearanceCategory';
import EditPreClearanceCategoryPage from '@app/pages/PreClearanceCategoryPage/EditPreClearanceCategory';
import ViewPreClearanceCategoryPage from '@app/pages/PreClearanceCategoryPage/ViewPreClearanceCategory';
import EditRenewal from '@app/pages/ProductRegistrationPages/EditRenewal';
import EditAppeal from '@app/pages/ProductRegistrationPages/EditAppeal';
import InvoicePage from '@app/pages/InvoicePage/InvoicePage';
import CertificatePage from '@app/pages/CertificatePage/CertificatePage';
import AllImport from '@app/pages/ImportPages/AllImport';
import EditImportPage from '@app/pages/ImportPages/EditImport';
import ViewImportPage from '@app/pages/ImportPages/ViewImport';
import CreateImportPage from '@app/pages/ImportPages/CreateImport';
import AllFeedProductions from '@app/pages/FeedProductionPages/AllFeedProductions';
import AddFeedProduction from '@app/pages/FeedProductionPages/AddFeedProduction';
import ViewFeedProduction from '@app/pages/FeedProductionPages/ViewFeedProduction';
import EditFeedProduction from '@app/pages/FeedProductionPages/EditFeedProduction';
import AllFeedForecasts from '@app/pages/FeedForecastpages/AllFeedForecasts';
import AddFeedForecast from '@app/pages/FeedForecastpages/AddFeedForecast';
import ViewFeedForecast from '@app/pages/FeedForecastpages/ViewFeedForecast';
import EditFeedForecast from '@app/pages/FeedForecastpages/EditFeedForecast';
import AllExpIngredients from '@app/pages/FeedExpIngredientsPages/AllExpIngredients';
import AddExpIngredient from '@app/pages/FeedExpIngredientsPages/AddExpIngredient';
import ViewExpIngredient from '@app/pages/FeedExpIngredientsPages/ViewExpIngredient';
import EditExpIngredient from '@app/pages/FeedExpIngredientsPages/EditExpIngredient';
import AllFeedUsage from '@app/pages/FeedMaterialUsagePages/AllFeedUsage';
import AddFeedUsage from '@app/pages/FeedMaterialUsagePages/AddFeedUsage';
import ViewFeedUsage from '@app/pages/FeedMaterialUsagePages/ViewFeedUsage';
import EditFeedUsage from '@app/pages/FeedMaterialUsagePages/EditFeedUsage';
import AllFeedImports from '@app/pages/FeedImports/AllFeedImports';
import AddFeedImport from '@app/pages/FeedImports/AddFeedImport';
import ViewFeedImport from '@app/pages/FeedImports/ViewFeedImport';
import EditFeedImport from '@app/pages/FeedImports/EditFeedImport';
import AllPostCategories from '@app/pages/PostCategoryPage/AllPostCategories';
import CreatePostCategories from '@app/pages/PostCategoryPage/CreatePostCategories';
import EditPostCategories from '@app/pages/PostCategoryPage/EditPostCategories';
import ViewPostCategories from '@app/pages/PostCategoryPage/ViewPostCategories';
import AllPosts from '@app/pages/PostPage/AllPosts';
import CreatePost from '@app/pages/PostPage/CreatePost';
import EditPost from '@app/pages/PostPage/EditPost';
import ViewPost from '@app/pages/PostPage/ViewPost';
import AllLabTasks from '@app/pages/LabPages/AllLabTasks';
import CreateLabTask from '@app/pages/LabPages/CreateLabTask';
import EditLabTask from '@app/pages/LabPages/EditLabTask';
import ViewLabTask from '@app/pages/LabPages/ViewLabTask';
import AllFollowUp from '@app/pages/FollowUpPage/AllFollowUp';
import CreateFollowUp from '@app/pages/FollowUpPage/CreateFollowUp';
import ViewFollowUp from '@app/pages/FollowUpPage/ViewFollowUp';
import EditFollowUp from '@app/pages/FollowUpPage/EditFollowUp';
import ImportInvoice from '@app/pages/InvoicePage/ImportInvoice';
import AllLabServices from '@app/pages/LabServicePages/AllLabService';
import ViewLabService from '@app/pages/LabServicePages/ViewLabService';
import EditLabService from '@app/pages/LabServicePages/EditLabService';
import AllNominalPayments from '@app/pages/NominalPaymentPages/AllNominalPayments';
import CreateNominalPayment from '@app/pages/NominalPaymentPages/CreateNominalPayment';
import EditNominalPayment from '@app/pages/NominalPaymentPages/EditNominalPayment';
import ViewNominalPayment from '@app/pages/NominalPaymentPages/ViewNominalPayment';
import AllExport from '@app/pages/ExportPages/AllExport';
import CreateExport from '@app/pages/ExportPages/CreateExport';
import ViewExport from '@app/pages/ExportPages/ViewExport';
import EditExport from '@app/pages/ExportPages/EditExport';
import NomPayInvoicePage from '@app/pages/InvoicePage/NomPayInvoice';
import AllReports from '@app/pages/ReportsPage/ReportTypes';
import ReportPage from '@app/pages/ReportsPage/ReportPage';
import AllExportExtension from '@app/pages/ExportExtention/AllExportExtension';
import CreateExportExtension from '@app/pages/ExportExtention/CreateExportExtension';
import ViewExportExtension from '@app/pages/ExportExtention/ViewExportExtension';
import EditExportExtension from '@app/pages/ExportExtention/EditExportExtension';
import PRCategoriesPage from '@app/pages/ProductRegistrationPages/PRCategory';
import AdditionalReportPage from '@app/pages/ReportsPage/AdditionalReportPage';
import AllFarms from '@app/pages/FarmLocations/AllFarms';
import RegisterFarm from '@app/pages/FarmLocations/RegisterFarm';
import ViewFarm from '@app/pages/FarmLocations/ViewFarm';
import EditFarm from '@app/pages/FarmLocations/EditFarm';
import AllInvoices from '@app/pages/Finances/AllInvoices';
import AllReceipts from '@app/pages/Finances/AllReciepts';
import ReceiptPage from '@app/pages/ReceiptPage/ReceiptPage';
import ViewLogs from '@app/pages/ActivityLog/ViewActivityLog';

const ErrorPage = React.lazy(() => import('@app/components/Error/ErrorPage'));
const Error = withLoading(ErrorPage);
const NewsFeedPage = React.lazy(() => import('@app/pages/NewsFeedPage'));
const DataTablesPage = React.lazy(() => import('@app/pages/DataTablesPage'));
const ChartsPage = React.lazy(() => import('@app/pages/ChartsPage'));
const ServerErrorPage = React.lazy(() => import('@app/pages/ServerErrorPage'));
const Error404Page = React.lazy(() => import('@app/pages/Error404Page'));
const AdvancedFormsPage = React.lazy(() => import('@app/pages/AdvancedFormsPage'));
const PersonalInfoPage = React.lazy(() => import('@app/pages/PersonalInfoPage'));
const SecuritySettingsPage = React.lazy(() => import('@app/pages/SecuritySettingsPage'));
const NotificationsPage = React.lazy(() => import('@app/pages/NotificationsPage'));
const PaymentsPage = React.lazy(() => import('@app/pages/PaymentsPage'));
const ButtonsPage = React.lazy(() => import('@app/pages/uiComponentsPages/ButtonsPage'));
const SpinnersPage = React.lazy(() => import('@app/pages/uiComponentsPages/SpinnersPage'));
const AvatarsPage = React.lazy(() => import('@app/pages/uiComponentsPages/dataDisplay/AvatarsPage'));
const BadgesPage = React.lazy(() => import('@app/pages/uiComponentsPages/dataDisplay/BadgesPage'));
const CollapsePage = React.lazy(() => import('@app/pages/uiComponentsPages/dataDisplay/CollapsePage'));
const PaginationPage = React.lazy(() => import('@app/pages/uiComponentsPages/dataDisplay/PaginationPage'));
const ModalsPage = React.lazy(() => import('@app/pages/uiComponentsPages/modals/ModalsPage'));
const PopoversPage = React.lazy(() => import('@app/pages/uiComponentsPages/modals/PopoversPage'));
const PopconfirmsPage = React.lazy(() => import('@app/pages/uiComponentsPages/modals/PopconfirmsPage'));
const ProgressPage = React.lazy(() => import('@app/pages/uiComponentsPages/feedback/ProgressPage'));
const ResultsPage = React.lazy(() => import('@app/pages/uiComponentsPages/feedback/ResultsPage'));
const AlertsPage = React.lazy(() => import('@app/pages/uiComponentsPages/feedback/AlertsPage'));
const SkeletonsPage = React.lazy(() => import('@app/pages/uiComponentsPages/feedback/SkeletonsPage'));
const InputsPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/InputsPage'));
const CheckboxesPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/CheckboxesPage'));
const RadiosPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/RadiosPage'));
const SelectsPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/SelectsPage'));
const SwitchesPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/SwitchesPage'));
const UploadsPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/UploadsPage'));
const RatesPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/RatesPage'));
const AutoCompletesPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/AutoCompletesPage'));
const StepsPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/StepsPage'));
const DateTimePickersPage = React.lazy(() => import('@app/pages/uiComponentsPages/forms/DateTimePickersPage'));
const DropdownsPage = React.lazy(() => import('@app/pages/uiComponentsPages/DropdownsPage'));
const BreadcrumbsPage = React.lazy(() => import('@app/pages/uiComponentsPages/navigation/BreadcrumbsPage'));
const TabsPage = React.lazy(() => import('@app/pages/uiComponentsPages/navigation/TabsPage'));
const NotificationsUIPage = React.lazy(() => import('@app/pages/uiComponentsPages/feedback/NotificationsPage'));
const GoogleMaps = React.lazy(() => import('@app/pages/maps/GoogleMapsPage/GoogleMapsPage'));
const LeafletMaps = React.lazy(() => import('@app/pages/maps/LeafletMapsPage/LeafletMapsPage'));
const ReactSimpleMaps = React.lazy(() => import('@app/pages/maps/ReactSimpleMapsPage/ReactSimpleMapsPage'));
const PigeonsMaps = React.lazy(() => import('@app/pages/maps/PigeonsMapsPage/PigeonsMapsPage'));
const Logout = React.lazy(() => import('./Logout'));

export const HOME_PATH = '/';
export const NFT_DASHBOARD_PATH = '/net-dashboard';
export const MEDICAL_DASHBOARD_PATH = '/medical-dashboard';

const Home = withLoading(HomePage);

const MedicalDashboard = withLoading(MedicalDashboardPage);
const NftDashboard = withLoading(NftDashboardPage);
const NewsFeed = withLoading(NewsFeedPage);
const AdvancedForm = withLoading(AdvancedFormsPage);

// UI Components
const Buttons = withLoading(ButtonsPage);
const Spinners = withLoading(SpinnersPage);
const Inputs = withLoading(InputsPage);
const Checkboxes = withLoading(CheckboxesPage);
const Radios = withLoading(RadiosPage);
const Selects = withLoading(SelectsPage);
const Switches = withLoading(SwitchesPage);
const Uploads = withLoading(UploadsPage);
const Rates = withLoading(RatesPage);
const AutoCompletes = withLoading(AutoCompletesPage);
const Steps = withLoading(StepsPage);
const DateTimePickers = withLoading(DateTimePickersPage);
const Dropdowns = withLoading(DropdownsPage);
const Breadcrumbs = withLoading(BreadcrumbsPage);
const Tabs = withLoading(TabsPage);
const Avatars = withLoading(AvatarsPage);
const Badges = withLoading(BadgesPage);
const Collapse = withLoading(CollapsePage);
const Pagination = withLoading(PaginationPage);
const Modals = withLoading(ModalsPage);
const Popovers = withLoading(PopoversPage);
const Popconfirms = withLoading(PopconfirmsPage);
const Progress = withLoading(ProgressPage);
const Results = withLoading(ResultsPage);
const Alerts = withLoading(AlertsPage);
const NotificationsUI = withLoading(NotificationsUIPage);
const Skeletons = withLoading(SkeletonsPage);

const DataTables = withLoading(DataTablesPage);
const Charts = withLoading(ChartsPage);

// Maps
const Google = withLoading(GoogleMaps);
const Leaflet = withLoading(LeafletMaps);
const ReactSimple = withLoading(ReactSimpleMaps);
const Pigeons = withLoading(PigeonsMaps);

const ServerError = withLoading(ServerErrorPage);
const Error404 = withLoading(Error404Page);

// Profile
const PersonalInfo = withLoading(PersonalInfoPage);
const SecuritySettings = withLoading(SecuritySettingsPage);
const Notifications = withLoading(NotificationsPage);
const Payments = withLoading(PaymentsPage);

const AuthLayoutFallback = withLoading(AuthLayout);
const LogoutFallback = withLoading(Logout);

export const AppRouter: React.FC = () => {
  const protectedLayout = (
    <RequireAuth>
      <MainLayout />
    </RequireAuth>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path={HOME_PATH}>
          <Route index element={<Home />} />
          <Route path="login" element={<CustomerLogin />} />
          <Route path="register" element={<CustomerLogin />} />
          <Route path={NFT_DASHBOARD_PATH} element={<NftDashboard />} />
        </Route>
        <Route path={HOME_PATH} element={protectedLayout}>
          <Route path="user-roles" element={<AllUserRoles />} />
          <Route path="add-roles" element={<CreateUserRolePage />} />
          <Route path="edit-role" element={<EditUserRolePage />} />
          <Route path="view-role" element={<ViewUserRolePage />} />

          <Route path="users" element={<AllUsers />} />
          <Route path="add-users" element={<CreateUserPage />} />
          <Route path="edit-user" element={<EditUserPage />} />
          <Route path="view-user" element={<ViewUserPage />} />

          <Route path="products" element={<AllProducts />} />
          <Route path="add-product" element={<CreateProductPage />} />
          <Route path="edit-product" element={<EditProductPage />} />
          <Route path="view-product" element={<ViewProductPage />} />

          <Route path="product-categories" element={<AllCategories />} />
          <Route path="add-product-category" element={<CreateCategory />} />
          <Route path="edit-product-category" element={<EditCategory />} />
          <Route path="view-product-category" element={<ViewCategory />} />

          <Route path="product-varieties" element={<AllProductVarietiesPage />} />
          <Route path="add-product-variety" element={<CreateProductVarietiesPage />} />
          <Route path="edit-product-variety" element={<EditProductVarietiesPage />} />
          <Route path="view-product-variety" element={<ViewProductVarietiesPage />} />

          {/* Product Registration Form Pages */}
          <Route path="pr-categories" element={<PRCategoriesPage />} />

          <Route path="product-registrations" element={<AllRegistrations />} />
          <Route path="register-products" element={<RegisterProductPage />} />

          <Route path="edit-product-registrations" element={<EditPRIFSPage />} />
          <Route path="view-product-registrations" element={<ViewPRIFSPage />} />
          <Route path="edit-product-registrations-renewal" element={<EditRenewal />} />
          <Route path="edit-product-registrations-appeal" element={<EditAppeal />} />

          {/* Farm Registration */}
          <Route path="all-farms" element={<AllFarms />} />
          <Route path="register-farm" element={<RegisterFarm />} />
          <Route path="view-farm" element={<ViewFarm />} />
          <Route path="edit-farm" element={<EditFarm />} />

          {/* Feed Productions */}
          <Route path="feed-productions" element={<AllFeedProductions />} />
          <Route path="add-feed-productions" element={<AddFeedProduction />} />
          <Route path="view-feed-production" element={<ViewFeedProduction />} />
          <Route path="edit-feed-production" element={<EditFeedProduction />} />

          {/* Feed Forecasts */}
          <Route path="feed-forecasts" element={<AllFeedForecasts />} />
          <Route path="add-feed-forecast" element={<AddFeedForecast />} />
          <Route path="view-feed-forecast" element={<ViewFeedForecast />} />
          <Route path="edit-feed-forecast" element={<EditFeedForecast />} />

          {/* Feed Expected Ingredients */}
          <Route path="feed-exp-ingredients" element={<AllExpIngredients />} />
          <Route path="add-exp-ingredient" element={<AddExpIngredient />} />
          <Route path="view-exp-ingredient" element={<ViewExpIngredient />} />
          <Route path="edit-exp-ingredient" element={<EditExpIngredient />} />

          {/* Feed Material Usage */}
          <Route path="feed-material-usage" element={<AllFeedUsage />} />
          <Route path="add-feed-usage" element={<AddFeedUsage />} />
          <Route path="view-feed-usage" element={<ViewFeedUsage />} />
          <Route path="edit-feed-usage" element={<EditFeedUsage />} />

          {/* Feed Imports */}
          <Route path="feed-imports" element={<AllFeedImports />} />
          <Route path="add-feed-import" element={<AddFeedImport />} />
          <Route path="view-feed-import" element={<ViewFeedImport />} />
          <Route path="edit-feed-import" element={<EditFeedImport />} />

          {/* Product Registration Categories */}
          <Route path="product-registrations-categories" element={<AllPRCategories />} />
          <Route path="add-product-registration-category" element={<CreatePRCategoryPage />} />
          <Route path="edit-product-registration-category" element={<EditPRCategoryPage />} />
          <Route path="view-product-registration-category" element={<ViewPRCategoryPage />} />

          {/* Product Registration products */}
          <Route path="product-registration-products" element={<AllPRProducts />} />
          <Route path="add-product-registration-product" element={<CreatePRProductPage />} />
          <Route path="edit-product-registration-product" element={<EditPRProductPage />} />
          <Route path="view-product-registration-product" element={<ViewPRProductPage />} />

          {/* Product Registration Processes */}
          <Route path="product-registration-processes" element={<AllPRProcesses />} />
          <Route path="add-product-registration-process" element={<CreatePRProcessPage />} />
          <Route path="edit-product-registration-process" element={<EditPRProcessPage />} />
          <Route path="view-product-registration-process" element={<ViewPRProcessPage />} />

          {/* Pre-Clearance Categories */}
          <Route path="pre-clearance-categories" element={<AllPreClearanceCategories />} />
          <Route path="add-pre-clearance-category" element={<CreatePreClearanceCategoryPage />} />
          <Route path="edit-pre-clearance-category" element={<EditPreClearanceCategoryPage />} />
          <Route path="view-pre-clearance-category" element={<ViewPreClearanceCategoryPage />} />

          <Route path="locations" element={<AllLocations />} />
          <Route path="add-location" element={<CreateLocationPage />} />
          <Route path="edit-location" element={<EditLocationPage />} />
          <Route path="view-location" element={<ViewLocationPage />} />

          <Route path="departments" element={<AllDepartments />} />
          <Route path="add-department" element={<CreateDepartmentPage />} />
          <Route path="edit-department" element={<EditDepartmentPage />} />
          <Route path="view-department" element={<ViewDepartmentPage />} />

          <Route path="verified-customers" element={<CustomersPage verified={true} />} />
          <Route path="new-customers" element={<CustomersPage verified={false} />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="view-customer" element={<ViewCustomerPage />} />
          <Route path="edit-customer" element={<EditCustomerPage />} />

          <Route path="add-product-pricing" element={<CreateProductPricingPage />} />
          <Route path="view-product-pricing" element={<ViewProductPricingPage />} />
          <Route path="edit-product-pricing" element={<EditProductPricingPage />} />

          <Route path="my-account" element={<MyAccountsPage />} />

          <Route path="pre-clearance" element={<AllPreClearance />} />
          <Route path="add-pre-clearance" element={<CreatePreClearancePage />} />
          <Route path="edit-pre-clearance" element={<EditPreClearancePage />} />
          <Route path="view-pre-clearance" element={<ViewPreClearancePage />} />

          {/* Invoices & Other routes */}
          <Route path="view-invoice" element={<InvoicePage />} />
          <Route path="all-invoices" element={<AllInvoices />} />
          <Route path="view-certificate" element={<CertificatePage />} />
          <Route path="all-receipts" element={<AllReceipts />} />
          <Route path="view-receipt" element={<ReceiptPage />} />

          {/* imports */}
          <Route path="import/normal" element={<AllImport />} />
          <Route path="import/non-compliance-1" element={<AllImport />} />
          <Route path="import/non-compliance-3" element={<AllImport />} />
          <Route path="import/no-objection" element={<AllImport />} />
          <Route path="import/non-relevant" element={<AllImport />} />

          <Route path="add-import" element={<CreateImportPage />} />
          <Route path="edit-import" element={<EditImportPage />} />
          <Route path="view-import" element={<ViewImportPage />} />

          <Route path="import-invoice" element={<ImportInvoice />} />

          {/* export */}
          <Route path="export/normal" element={<AllExport />} />
          <Route path="export/feed-and-drugs" element={<AllExport />} />

          <Route path="add-export" element={<CreateExport />} />
          <Route path="edit-export" element={<EditExport />} />
          <Route path="view-export" element={<ViewExport />} />
          {/* export-extention*/}
          <Route path="export-extensions" element={<AllExportExtension />} />
          <Route path="add-export-extension" element={<CreateExportExtension />} />
          <Route path="edit-export-extension" element={<EditExportExtension />} />
          <Route path="view-export-extension" element={<ViewExportExtension />} />

          {/* Follow-up */}
          <Route path="follow-ups" element={<AllFollowUp />} />
          <Route path="add-follow-up" element={<CreateFollowUp />} />
          <Route path="edit-follow-up" element={<EditFollowUp />} />
          <Route path="view-follow-up" element={<ViewFollowUp />} />

          {/* Post categories */}
          <Route path="post-categories" element={<AllPostCategories />} />
          <Route path="add-post-category" element={<CreatePostCategories />} />
          <Route path="edit-post-category" element={<EditPostCategories />} />
          <Route path="view-post-category" element={<ViewPostCategories />} />

          {/* Post */}
          <Route path="posts" element={<AllPosts />} />
          <Route path="add-post" element={<CreatePost />} />
          <Route path="edit-post" element={<EditPost />} />
          <Route path="view-post" element={<ViewPost />} />

          {/* Labs & Research */}
          <Route path="lab-regular-tests" element={<AllLabTasks />} />
          <Route path="lab-aqo-initiated" element={<AllLabTasks />} />
          <Route path="lab-bi-annual-tests" element={<AllLabTasks />} />
          <Route path="lab-direct-sales" element={<AllLabTasks />} />
          <Route path="lab-vaccine-manufacture" element={<AllLabTasks />} />
          <Route path="lab-disease-surveillance" element={<AllLabTasks />} />

          <Route path="add-lab-task" element={<CreateLabTask />} />
          <Route path="edit-lab-task" element={<EditLabTask />} />
          <Route path="view-lab-task" element={<ViewLabTask />} />

          {/* Lab Service Config */}
          <Route path="lab-services" element={<AllLabServices />} />
          <Route path="view-lab-service" element={<ViewLabService />} />
          <Route path="edit-lab-service" element={<EditLabService />} />

          {/* Nominal Payments */}
          <Route path="nominal-payments" element={<AllNominalPayments />} />
          <Route path="add-nominal-payment" element={<CreateNominalPayment />} />
          <Route path="edit-nominal-payment" element={<EditNominalPayment />} />
          <Route path="view-nominal-payment" element={<ViewNominalPayment />} />

          <Route path="view-nompay-invoice" element={<NomPayInvoicePage />} />

          {/* Reports */}
          <Route path="lab-reports" element={<AllReports />} />
          <Route path="pr-license-reports" element={<AllReports />} />
          <Route path="import-export-reports" element={<AllReports />} />
          <Route path="finance-reports" element={<AllReports />} />

          <Route path="/report" element={<ReportPage />} />
          <Route path="/report/detailed" element={<AdditionalReportPage />} />

          <Route path="server-error" element={<ServerError />} />
          <Route path="error" element={<Error />} />

          {/* Activity Log */}
          <Route path="activity_log" element={<ViewLogs />} />

          {/* Dashboard */}

          {/* <Route path={NFT_DASHBOARD_PATH} element={<NftDashboard />} /> */}
        </Route>
        {/* <Route path={NFT_DASHBOARD_PATH} element={<NftDashboard />} />
          <Route path={MEDICAL_DASHBOARD_PATH} element={<MedicalDashboard />} />
          
          <Route path="apps">
            <Route path="feed" element={<NewsFeed />} />
          </Route>
          <Route path="forms">
            <Route path="advanced-forms" element={<AdvancedForm />} />
          </Route>
          <Route path="data-tables" element={<DataTables />} />
          <Route path="charts" element={<Charts />} />
          <Route path="maps">
            <Route path="google-maps" element={<Google />} />
            <Route path="leaflet-maps" element={<Leaflet />} />
            <Route path="react-simple-maps" element={<ReactSimple />} />
            <Route path="pigeon-maps" element={<Pigeons />} />
          </Route>
          <Route path="server-error" element={<ServerError />} />
          <Route path="404" element={<Error404 />} />
          <Route path="profile" element={<ProfileLayout />}>
            <Route path="personal-info" element={<PersonalInfo />} />
            <Route path="security-settings" element={<SecuritySettings />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="payments" element={<Payments />} />
          </Route>
          <Route path="ui-components">
            <Route path="button" element={<Buttons />} />
            <Route path="spinner" element={<Spinners />} />
            <Route path="input" element={<Inputs />} />
            <Route path="checkbox" element={<Checkboxes />} />
            <Route path="radio" element={<Radios />} />
            <Route path="select" element={<Selects />} />
            <Route path="switch" element={<Switches />} />
            <Route path="upload" element={<Uploads />} />
            <Route path="rate" element={<Rates />} />
            <Route path="auto-complete" element={<AutoCompletes />} />
            <Route path="steps" element={<Steps />} />
            <Route path="date-time-picker" element={<DateTimePickers />} />
            <Route path="dropdown" element={<Dropdowns />} />
            <Route path="breadcrumbs" element={<Breadcrumbs />} />
            <Route path="tabs" element={<Tabs />} />
            <Route path="avatar" element={<Avatars />} />
            <Route path="badge" element={<Badges />} />
            <Route path="collapse" element={<Collapse />} />
            <Route path="pagination" element={<Pagination />} />
            <Route path="modal" element={<Modals />} />
            <Route path="popover" element={<Popovers />} />
            <Route path="popconfirm" element={<Popconfirms />} />
            <Route path="progress" element={<Progress />} />
            <Route path="result" element={<Results />} />
            <Route path="alert" element={<Alerts />} />
            <Route path="notification" element={<NotificationsUI />} />
            <Route path="skeleton" element={<Skeletons />} />
          </Route>
        </Route>
        */}

        <Route path="/auth" element={<AuthLayoutFallback />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route
            path="lock"
            element={
              <RequireAuth>
                <LockPage />
              </RequireAuth>
            }
          />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="security-code" element={<SecurityCodePage />} />
          <Route path="new-password" element={<NewPasswordPage />} />
        </Route>
        <Route path="/logout" element={<LogoutFallback />} />
      </Routes>
    </BrowserRouter>
  );
};
